"use strict";
var employeeList = document.querySelector("ul");
function parseSalary(salaryString) {
    var cleanString = salaryString.replaceAll("$", "").replaceAll(",", "");
    return Number(cleanString);
}
function sortList(list) {
    var itemsArray = Array.from(list.children);
    itemsArray.sort(function(itemA, itemB) {
        var salaryA = parseSalary(itemA.dataset.salary);
        var salaryB = parseSalary(itemB.dataset.salary);
        return salaryB - salaryA;
    });
    itemsArray.forEach(function(item) {
        list.appendChild(item);
    });
}
function getEmployees(list) {
    var itemsArray = Array.from(list.children);
    return itemsArray.map(function(item) {
        return {
            name: item.textContent.trim(),
            position: item.dataset.position,
            salary: parseSalary(item.dataset.salary),
            age: Number(item.dataset.age)
        };
    });
}
sortList(employeeList);
getEmployees(employeeList); // const employeesData = getEmployees(employeeList);
 // console.log(employeesData);

//# sourceMappingURL=index.c50db1d8.js.map
